import React from 'react';
import styled from '@emotion/styled';
import type { StringMap } from 'corgi-types';

import Alert from 'common/components/Alert';
// import { linkStyles } from 'common/components/Link';
import { useLocalization } from 'common/providers/LocaleProvider';
import type { HeaderOptions } from '../components/constants';

interface AlertProps {
  alertType: HeaderOptions['alertType'];
  alertMessage: HeaderOptions['alertMessage'];
  alertTranslationProps: StringMap<string | number>;
}

const StyledContent = styled.div`
  a {
    color: inherit;
    text-decoration: underline;
  }
`;

export const AlertWithHtml = ({ alertType, alertMessage, alertTranslationProps }: AlertProps) => {
  const { r } = useLocalization();

  return alertType && alertMessage ? (
    <Alert type={alertType} mt="sp_16">
      <StyledContent
        dangerouslySetInnerHTML={{ __html: r.t(alertMessage, alertTranslationProps) }}
      />
    </Alert>
  ) : null;
};
